import * as React from 'react';
import { getIsWhiteLabel } from '../../redux/modules/whiteLabel';
import isEqual from 'react-fast-compare';
import LACrown from './LACrown/LACrown';
import { useSelector } from 'react-redux';
import WhiteLabelCrown from './WhiteLabelCrown/WhiteLabelCrown';

const Crown = () => {
    const whiteLabel = useSelector(getIsWhiteLabel, isEqual);
    return whiteLabel ? <WhiteLabelCrown /> : <LACrown />;
};

// because whitelabel will never update we can keep memo
export default React.memo(Crown);
